// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__Ys8RJ","choiceBoxes":"toolbarselects_choiceBoxes__3ImGd","simpleField":"toolbarselects_simpleField__33chL"};